import logo from "@/assets/logo_salone_vincente.png";

const ThankYou = () => {
  return (
    <div className="min-h-screen gradient-subtle flex flex-col items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center">
        <div className="flex justify-center mb-6 animate-fade-in">
          <img 
            src={logo} 
            alt="Salone Vincente" 
            className="w-24 h-24 object-contain animate-float"
          />
        </div>
        
        <div className="card p-8 shadow-elegant animate-slide-up">
          <h1 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent">
            Grazie!
          </h1>
          
          <p className="text-lg md:text-xl text-foreground/90">
            Verrai contattato a breve per fissare l'appuntamento con Matteo! A presto
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
